export default {
  title: 'Como Fizemos as Contas',
  image: require('@/assets/images/post/hero-comofizemosascontas.jpg'),
  credits: 'Crédito Paulo Pereira/Oxfam Brasil',
  subtitle: 'Utilizamos as bases de dados públicas existentes para estimar impactos dos impostos em nossas vidas.',
  content: [
    {
      type: 'text',
      data: `
      <h2>EXPLICAÇÃO DA METODOLOGIA</h2>

      <p>Por trás dos números do ‘Valor do Seu Imposto’, há uma base de dados inédita,
      formada por nós a partir da junção de produtos de diferentes pesquisas e dados
      públicos.

      <h2>Etapa 1 – Elaboração da base de dados</h2>

      <p>As bases de dados com as quais trabalhamos foram a Pesquisa Nacional por Amostra
      de Domicílio – PNAD (IBGE), a Pesquisa de Orçamento Familiar – POF (IBGE) e os
      grandes números das Declarações de Imposto de Renda de Pessoas Físicas – DIRPF
      (Receita Federal). Mas para que tanto dado, e como se deu essa “junção”?</p>
      
      <p>A PNAD nos oferece dados pormenorizados de rendimentos (totais, só do trabalho ou
      de outras fontes). Selecionamos trabalhar com os dados da população brasileira adulta
      com renda.</p>

      <p>Para as menores rendas, realizamos uma correção com um vetor da POF, a partir da
      observação de possível subdeclaração de rendimentos por parte dos entrevistados. Já
      para as maiores rendas, utilizamos os grandes números das DIRPF nos proporcionam
      dados mais acurados da tributação de renda e da renda “do topo”, porém de modo
      agregado, mas que permitem uma correção importante. Em outras palavras, as DIRPF
      revelam rendimentos maiores do topo do que aqueles aferidos pela PNAD, já que o
      acesso dos pesquisadores aos mais ricos na PNAD é mais limitada.</p>

      <p>Os dados da POF também nos permitem saber, além da renda domiciliar per capita, o
      padrão de consumo dos brasileiros. Com base nisso, é possível calcular a incidência de
      uma outra gama de tributos – aqueles sobre patrimônio e os tributos sobre bens e
      serviços que incidem nas famílias. A montagem da base geral se deu em três passos.</p>

      <p>O passo 1 foi a junção dos dados da PNAD 2015 com os dados da Receita Federal do
      mesmo ano, substituindo o “topo” da PNAD por dados da Receita. Com isso,
      obtivemos uma melhor distribuição de renda do que a PNAD nos oferece. O ano de
      2015 foi escolhido pela atualidade dos dados tributários à época de nossos cálculos.</p>

      <p>O passo 2 foi a preparação da POF 2008/2009 para se conectar com a base que é de
      2015. Uma atualização nos parâmetros foi aplicada para que a POF pudesse ser
      conectada com a base de renda. A renda da POF também foi ajustada com os valores
      do topo da renda dos dados da Receita Federal. Uma vez mais, tivemos que usar a
      base de 2008 por ser a mais atual à época dos nossos cálculos.</p>

      <p>O passo 3 foi a conexão dos dados da PNAD com os dados da POF atualizada a 2015.
      Com isso, criamos uma “superbase” de dados, agrupadas por cada 2 milésimos da
      população adulta (18 anos ou mais) com renda positiva, ou seja, em estratos de 1/500
      avos dessa população (grupos de cerca de 240 mil pessoas). Isso nos oferece suporte
      para cálculos de posição na distribuição de renda, faixa média de renda, incidência de
      tributos direitos e indiretos, além de outras informações.</p>

      <h2>Etapa 2 – Desenho da Calculadora</h2>

      <p>Para a elaboração do gráfico da calculadora, utilizando a base de dados da etapa 1,
      foram selecionados 20 grupos, a cada 5 centésimos da população adulta com renda.
      Para cada um desses grupos, os rendimentos foram corrigidos pelo deflator da PNAD,
      para funcionar como a entrada de informação na calculadora.</p>

      <p>Para cada um dos 20 grupos de renda foram selecionadas da base de dados as
      informações referentes à proporção de renda dedicada ao pagamento de tributos
      totais, que somam os tributos indiretos (ICMS, IPI, PIS/PASEP, CONFINS, ISS E CIDE) e
      diretos (Contribuição previdenciária, IPTU, IPVA, IRPF). Esse resultado da calculadora
      aparece no formato de gráfico, indicando a posição na distribuição de renda e de
      percentual de renda dedicado ao pagamento de tributos da pessoa que tiver inserido
      sua renda total na ferramenta.</p>

      <p>Por fim, para mostrar o valor social do imposto, foram calculados, com base nos
      tributos pagos por cada um dos 20 grupos de renda, quantos estudantes da educação
      fundamental são potencialmente financiados com esse valor anualmente ou quantas
      pessoas atendidas no SUS são potencialmente financiadas ou quantos metros quadros
      poderiam ser pavimentados para finalidades diversas ou quanto quilos de lixo
      poderiam ser coletados ou ainda quantos pontos de iluminação pública podem ser
      mantidos no ano.</p>
      <table width="100%" cellspacing="0" cellspadding="0">
        <tr>
          <td><b>Dado</b></td>
          <td><b>Valor (2019)</b></td>
          <td><b>Fonte</b></td>
        </tr>
        <tr>
          <td>m2 de pavimentação asfáltica</td>
          <td>R$66,00</td>
          <td>Edital de prefeitura</td>
        </tr>
        <tr>
          <td>kg de coleta de lixo</td>
          <td>R$54,00</td>
          <td>Edital de prefeitura</td>
        </tr>
        <tr>
          <td>ponto de iluminação pública no ano</td>
          <td>R$20,00</td>
          <td>Edital de prefeitura</td>
        </tr>
        <tr>
          <td>1 estudante nível fundamental no ano</td>
          <td>R$3.400,00</td>
          <td>Plano Nacional de Educação</td>
        </tr>
        <tr>
          <td>gasto por pessoa com saúde no ano</td>
          <td>R$1.280,00</td>
          <td>Conselho Federal de Medicina</td>
        </tr>
      </table>
      <div class="button--content">
      <a class="button button--download" target="_blank" href="metodologia-o-valor-do-seu-imposto.pdf"> Metodologia completa </a>
      </div>
      `,
    },
  ],
};
